import { render, staticRenderFns } from "./questionItemOperationData.vue?vue&type=template&id=a23ab614&scoped=true"
import script from "./questionItemOperationData.vue?vue&type=script&lang=js"
export * from "./questionItemOperationData.vue?vue&type=script&lang=js"
import style0 from "./questionItemOperationData.vue?vue&type=style&index=0&id=a23ab614&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23ab614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a23ab614')) {
      api.createRecord('a23ab614', component.options)
    } else {
      api.reload('a23ab614', component.options)
    }
    module.hot.accept("./questionItemOperationData.vue?vue&type=template&id=a23ab614&scoped=true", function () {
      api.rerender('a23ab614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/waybillKanbanBoard/component/questionItemOperationData.vue"
export default component.exports